import { useSelector } from 'react-redux'

import { selectUserRole } from '@/reducers/userDataReducer'

import { AdminCommunityEssentialsPage } from './admin-community-essentials.page'
import { ClientCommunityEssentialsPage } from './client-community-essentials.page'
import { ADMIN_ROLES } from './community-essentials.constants'

export const CommunityEssentialsPage = () => {
  const role = useSelector(selectUserRole)
  // TODO: must be a part of global logic, replace when available
  const isAdmin = role !== null && ADMIN_ROLES.includes(role)

  if (isAdmin) {
    return <AdminCommunityEssentialsPage />
  }

  return <ClientCommunityEssentialsPage />
}
